function reports(state = {
    xlsx : {}
}, action) {
    if(action.type.startsWith('REPORTS_')) {
        const report = action.report.replace('-', '_');
        return {
            ...state,
            [report] : updateReportState(state[report], action)
        }
    } else if(action.type.startsWith('REPORT_')) {
        return {
            ...state,
            xlsx : updateXlsxRequestState(state, action)
        }
    }
    return state;
    
}

function updateReportState(state = {}, action) {
    switch(action.type) {
        case 'REPORTS_FETCH_START':
            return {
                data : {},
                fetching : true,
                error : null,
            }
        case 'REPORTS_FETCH_SUCCESS':
            const {data} = action;
            data.items = data.data;
            delete data.data;
            return {
                data,
                fetching : false,
                error : null,
            }
        case 'REPORTS_FETCH_FAILURE':
            return {
                data : {},
                fetching : false,
                error : action.error,   
            }
        
        default :
            return state;        
    }
}

function updateXlsxRequestState(state = {}, action) {
    switch(action.type) {
        case 'REPORT_REQUEST_START':
            return {
                requestData : {},
                requesting : true,
                requestError : null,
            }
        case 'REPORT_REQUEST_SUCCESS':
            return {
                requestData : action.data,
                requesting : false,
                requestError : null,
            }
        case 'REPORT_REQUEST_FAILURE':
            return {
                requestData : {},
                requesting : false,
                requestError : action.error,   
            }
        case 'REPORT_REQUEST_CLEAR' :
            return {};
        default :
            return state;
    }
}

export default reports;


/** WEBPACK FOOTER **
 ** ./src/reducers/reports.js
 **/